import styled from "styled-components";

const Container = styled.header`
  position: relative;
`;

const Title = styled.h1`
  color: white;
  font-weight: bold;
  font-size: 60px;
  margin: 0px;
  padding: 0px;
  text-transform: uppercase;
  @media (max-width: 1100px) {
    font-size: 45px;
  }
  @media (max-width: 850px) {
    font-size: 30px;
  }
`;

const Subtitle = styled.h1`
  color: #C1A886;
  letter-spacing: 0px;
  font-size: 20px;
  margin: 0px;
  padding: 0px;
  @media (max-width: 850px) {
    font-size: 12px;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: auto;
  max-height: 320px;
  @media (max-width: 850px) {
    height: 220px;
  }
`;

const Content = styled.div`
  position: absolute;
  bottom: 10px;
  margin: 0px ${props => props.margin? props.margin : '15%'};
  @media (max-width: 768px) {
    margin: 0px 20px;
  }
`;

export {
  Container,
  Title,
  Subtitle,
  ImageContainer,
  Content,
};